import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { IUser } from '@/types';

import http, { IApiErrorData } from './http';
import serviceHelper from './serviceHelper';

export const LoginApi = async (payload: IUser) => {
  try {
    const response = await http.post('/auth/admin/login', payload);
    return response;
  } catch (err: unknown) {
    const axiosError = err as AxiosError<IApiErrorData>;
    enqueueSnackbar(axiosError.response?.data.message, { variant: 'error' });
    return undefined;
  }
};

export const ForgotPasswordApi = async (payload: { email: string }) => {
  try {
    const response = await http.post('/auth/forgot-password', payload);
    return response;
  } catch (err: unknown) {
    const axiosError = err as AxiosError<IApiErrorData>;
    enqueueSnackbar(axiosError.response?.data.message, { variant: 'error' });
    return undefined;
  }
};

export const logoutApi = async (device_id?: string) => {
  return serviceHelper(http.post('/auth/admin/logout', { device_id }), false);
};

export const resetLinkVerification = async ({ token }: { token: string }) => {
  return serviceHelper(
    http.get('/auth/reset-password/validate', { params: { token } }),
    false,
    false
  );
};

export const resendPasswordLink = async ({ token }: { token: string }) => {
  return serviceHelper(
    http.post('/auth/reset-password/resend', { token }),
    false
  );
};

export const resetPasswordApi = async (payload: {
  token: string;
  password: string;
}) => {
  return serviceHelper(http.post('/auth/reset-password', payload), false);
};
